import type {Event, Page, Job, Analytics} from 'src/types/drive/drive';
import type {DriveActions} from 'src/action-creators/drive/drive';
import {
  DRIVE_EVENTS,
  DRIVE_EVENTS_LOADING,
  DRIVE_EVENTS_ERROR,
  DRIVE_CREATE_EVENT,
  DRIVE_CREATE_EVENT_LOADING,
  DRIVE_CREATE_EVENT_ERROR,
  DRIVE_EDIT_EVENT,
  DRIVE_EDIT_EVENT_LOADING,
  DRIVE_EDIT_EVENT_ERROR,
  DRIVE_EVENT,
  DRIVE_EVENT_LOADING,
  DRIVE_EVENT_ERROR,
  DRIVE_PAGES,
  DRIVE_PAGES_LOADING,
  DRIVE_PAGES_ERROR,
  DRIVE_STATUS_PUBLISH,
  DRIVE_STATUS_ARCHIVE,
  DRIVE_STATUS_UPDATE_LOADING,
  DRIVE_JOBS,
  DRIVE_JOBS_LOADING,
  DRIVE_JOBS_ERROR,
  DRIVE_LINK_PAGE,
  DRIVE_UNLINK_PAGE,
  DRIVE_LINK_PAGE_LOADING,
  DRIVE_LINK_PAGE_ERROR,
  DRIVE_LINKED_JOBS,
  DRIVE_LINKED_JOBS_LOADING,
  DRIVE_LINKED_JOBS_ERROR,
  DRIVE_LINK_JOBS,
  DRIVE_LINK_JOBS_LOADING,
  DRIVE_EVENT_ANALYTICS,
  DRIVE_EVENT_ANALYTICS_LOADING,
  DRIVE_EVENT_ANALYTICS_ERROR,
} from 'src/action-creators/drive/drive';


export const DriveCurrentState = {
  IDLE: 'IDLE',
  FETCHING_EVENTS: 'FETCHING_EVENTS',
  CREATE_EVENT: 'CREATE_EVENT',
  EDIT_EVENT: 'EDIT_EVENT',
  FETCHING_EVENT: 'FETCHING_EVENT',
  FETCHING_PAGES: 'FETCHING_PAGES',
  STATUS_UPDATE_EVENT: 'STATUS_UPDATE_EVENT',
  FETCHING_JOBS: 'FETCHING_JOBS',
  LINK_PAGE: 'LINK_PAGE',
  FETCHING_LINKED_JOBS: 'FETCHING_LINKED_JOBS',
  LINKING_JOBS: 'LINKING_JOBS',
  FETCHING_ANALYTICS: 'FETCHING_ANALYTICS',
} as const;

type DriveState = {
  current_state: string;
  events: Event[];
  pages: Page[];
  event: Event | null | undefined;
  jobs: Job[];
  linkedJobs?: Job[];
  analytics: Analytics[];
};

const initialState = {
  current_state: DriveCurrentState.IDLE,
  events: [],
  pages: [],
  jobs: [],
  event: null,
  linkedJobs: [],
  analytics: [],
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly current_state: "IDLE"; readonly events: readonly []; readonly pages: readonly []; readonly jobs: readonly []; readonly event: null; readonly linkedJobs: readonly []; readonly analytics: readonly []; }' is not assignable to type 'DriveState'.
  state: DriveState | null | undefined = initialState,
  action: DriveActions,
): DriveState => {
  switch (action.type) {
    case DRIVE_EVENTS:
      // @ts-expect-error - TS2322 - Type '{ events: Event[]; event: null; current_state: "IDLE"; pages?: Page[] | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        events: action.payload,
        event: null,
        current_state: DriveCurrentState.IDLE,
      };
    case DRIVE_EVENTS_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "FETCHING_EVENTS"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.FETCHING_EVENTS,
      };
    case DRIVE_EVENTS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.IDLE,
      };
    case DRIVE_CREATE_EVENT:
      // @ts-expect-error - TS2322 - Type '{ events: Event[]; current_state: "IDLE"; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        events: [...state.events, {...action.payload}],
        current_state: DriveCurrentState.IDLE,
      };
    case DRIVE_CREATE_EVENT_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "CREATE_EVENT"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.CREATE_EVENT,
      };
    case DRIVE_CREATE_EVENT_ERROR:
      // @ts-expect-error - TS2322 - Type '{ current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.IDLE,
      };
    case DRIVE_EDIT_EVENT:
      // @ts-expect-error - TS2322 - Type '{ events: Event[]; current_state: "IDLE"; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        events: state.events.map((event) => {
          if (event.id === action.payload.id) {
            return action.payload;
          }
          return event;
        }),
        current_state: DriveCurrentState.IDLE,
      };

    case DRIVE_EDIT_EVENT_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "EDIT_EVENT"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.EDIT_EVENT,
      };
    case DRIVE_EDIT_EVENT_ERROR:
      // @ts-expect-error - TS2322 - Type '{ current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.IDLE,
      };
    case DRIVE_EVENT:
      // @ts-expect-error - TS2322 - Type '{ event: Event; current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        event: action.payload,
        current_state: DriveCurrentState.IDLE,
      };
    case DRIVE_EVENT_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "FETCHING_EVENT"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.FETCHING_EVENT,
      };
    case DRIVE_EVENT_ERROR:
      // @ts-expect-error - TS2322 - Type '{ current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.IDLE,
      };
    case DRIVE_STATUS_UPDATE_LOADING: {
      // @ts-expect-error - TS2322 - Type '{ current_state: "STATUS_UPDATE_EVENT"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.STATUS_UPDATE_EVENT,
      };
    }
    case DRIVE_STATUS_PUBLISH:
    case DRIVE_STATUS_ARCHIVE:
      // @ts-expect-error - TS2322 - Type '{ event: Event; current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        event: action.payload,
        current_state: DriveCurrentState.IDLE,
      };

    case DRIVE_JOBS:
      // @ts-expect-error - TS2322 - Type '{ jobs: Job[]; current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        jobs: action.payload,
        current_state: DriveCurrentState.IDLE,
      };
    // @ts-expect-error - TS2678 - Type '"drive/jobs-loading"' is not comparable to type '"drive/events" | "drive/events-loading" | "drive/events-error" | "drive/create-event" | "drive/create-event-loading" | "drive/create-event-error" | "drive/edit-event" | ... 25 more ... | "drive/analytics-error"'.
    case DRIVE_JOBS_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "FETCHING_JOBS"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.FETCHING_JOBS,
      };
    case DRIVE_JOBS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.IDLE,
      };

    case DRIVE_PAGES:
      // @ts-expect-error - TS2322 - Type '{ pages: Page[]; current_state: "IDLE"; events?: Event[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        pages: action.payload,
        current_state: DriveCurrentState.IDLE,
      };
    case DRIVE_PAGES_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "FETCHING_PAGES"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.FETCHING_PAGES,
      };

    case DRIVE_LINK_PAGE:
      // @ts-expect-error - TS2322 - Type '{ event: Event; current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        event: action.payload,
        current_state: DriveCurrentState.IDLE,
      };

    case DRIVE_UNLINK_PAGE:
      // @ts-expect-error - TS2322 - Type '{ event: Event; current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        event: action.payload,
        current_state: DriveCurrentState.IDLE,
      };
    case DRIVE_LINK_PAGE_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "LINK_PAGE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.LINK_PAGE,
      };
    case DRIVE_LINK_PAGE_ERROR:
      // @ts-expect-error - TS2322 - Type '{ current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.IDLE,
      };

    case DRIVE_LINKED_JOBS:
      // @ts-expect-error - TS2322 - Type '{ linkedJobs: Job[]; current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        linkedJobs: action.payload,
        current_state: DriveCurrentState.IDLE,
      };

    case DRIVE_LINKED_JOBS_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "FETCHING_LINKED_JOBS"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.FETCHING_LINKED_JOBS,
      };

    case DRIVE_LINKED_JOBS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ current_state?: string | undefined; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
      };

    case DRIVE_LINK_JOBS:
      // @ts-expect-error - TS2322 - Type '{ linkedJobs: Job[]; current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        linkedJobs: action.payload,
        current_state: DriveCurrentState.IDLE,
      };

    case DRIVE_LINK_JOBS_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "LINKING_JOBS"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.LINKING_JOBS,
      };

    case DRIVE_EVENT_ANALYTICS:
      // @ts-expect-error - TS2322 - Type '{ analytics: Analytics[]; current_state: "IDLE"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        analytics: action.payload,
        current_state: DriveCurrentState.IDLE,
      };

    case DRIVE_EVENT_ANALYTICS_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "FETCHING_ANALYTICS"; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
        current_state: DriveCurrentState.FETCHING_ANALYTICS,
      };

    case DRIVE_EVENT_ANALYTICS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ current_state?: string | undefined; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
      };

    default:
      // @ts-expect-error - TS2322 - Type '{ current_state?: string | undefined; events?: Event[] | undefined; pages?: Page[] | undefined; event?: Event | null | undefined; jobs?: Job[] | undefined; linkedJobs?: Job[]; analytics?: Analytics[] | undefined; }' is not assignable to type 'DriveState'.
      return {
        ...state,
      };
  }
};
